import type { DragStartEvent } from '@dnd-kit/core';

export interface ICategoryConfirmDialogInfo {
  open: boolean;
  title: string;
  description: string;
  alertFor: string;
}

export interface ICategoryDragData {
  type?: string;
  container?: string;
  sectionId?: string;
  itemType?: string;
  itemName?: string;
  itemCode?: string;
}

export interface ICategoryDndSource {
  id: string | number;
  data: {
    current?: ICategoryDragData;
  };
}

export type IActiveDragItem = DragStartEvent['active'] | null;

export const INITIAL_CONFIRM_DIALOG: ICategoryConfirmDialogInfo = {
  open: false,
  title: '',
  description: '',
  alertFor: '',
};
